import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {StorageLinkPipe} from './storage-link.pipe';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        StorageLinkPipe
    ],
    exports: [
        StorageLinkPipe
    ]
})
export class StorageLinkModule {
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/storage-link/storage-link.module.ts